// tooltips.js — set up once, near your other app-init code
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/material.css';
import '@/styles/toolbar-tip.css';
import 'tippy.js/animations/scale.css';
import { currLang } from '@/scripts/translation.js';

tippy.setDefaultProps({
  theme: 'material',
  animation: 'scale',
  placement: 'bottom',
  arrow: true,
  offset: [0, 8],
  maxWidth: 220,
  delay: [200, 0],
  duration: [150, 100],
  zIndex: 9999,
});
// 2. One helper that accepts either a selector string, an element,
//    or a NodeList/array of elements — and skips silently-missing targets.
function registerTooltip(target, content, overrides = {}) {
  const els =
    typeof target === 'string'
      ? document.querySelectorAll(target)
      : target instanceof Element
        ? [target]
        : target;

  if (!els || !els.length) {
    console.warn('[tooltip] no matching element(s) for', target);
    return;
  }

  return tippy(els, { content, ...overrides });
}

// 3. One data source for every toolbar/button tooltip in the app.
// A function (not a static object) so it always reads the current language,
// even if this module was evaluated before the user's language was set.
function getTooltipMap() {
  return {
    '#run-btn': currLang['UI.RunCodeTooltip'],
    '#stop-btn': currLang['UI.StopExecutionTooltip'],
    '#share-access-btn': currLang['UI.RemoteDeviceAccessTooltip'],
    '#upload-model-btn': currLang['UI.UploadCustomMlModelTooltip'],
    '#rset-btn': currLang['UI.ClearWifiCredentialsTooltip'],
    '#import-btn': currLang['UI.ImportProjectTooltip'],
    '#export-btn': currLang['UI.ExportProjectTooltip'],
  };
}

function initToolbarTooltips() {
  Object.entries(getTooltipMap()).forEach(([selector, content]) => {
    registerTooltip(selector, content);
  });
}
export { registerTooltip, initToolbarTooltips };
